import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import GlobalCheckList from "../../pages/common/globalchecklist";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";

export default function StudentCheckList() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  return (
    <>
      {isStudent && <STopMenu slug={slug} activeMenu="PersonelQuestionsList" />}
      {isStudent12 && <S12TopMenu slug={slug} activeMenu="PersonelQuestionsList" />}
      <GlobalCheckList slug={slug} isStudent={true} />
    </>
  );
}
